// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"c29f42b8","254":"8ae10d44","578":"0377606f"}[chunkId] + ".chunk.js";
};